import { useQuery } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

export type CompanyTransactionsResponse = {
  transfers: [
    {
      externalTransferId: string
      status: string
      amount: {
        value: number
        currencyCode: {
          value: string
          displayName: string
          cultureName: string
        }
      }
      date: string
      senderName: string
      recipientName: string
      senderAccount: string
      recipientAccount: string
      isRefunded: true
      isReimbursed: true
      appliedForReimbursement: true
      recipientAddress: {
        streetNumberAndName: string
        apartmentNumber: string
        city: string
        zipCode: string
        state: string
        country: string
      }
    }
  ]
}

export function useCompanyTransactions(companyId: string) {
  return useQuery<CompanyTransactionsResponse>({
    queryKey: ["company/transactions", companyId],
    queryFn: async () => {
      const response = await fetcher(
        `/Company/${companyId}/Transactions`,
        {
          method: "GET",
        },
        {
          useAccessToken: true,
        }
      )
      const responseJson = await response.json()

      return responseJson
    },
  })
}
